/*******************************************************************************
 *** MbrAprvMngDialog ** 회원 상세정보/반려사유 입력 모달
********************************************************************************/
import React from "react";
import MbrAprvMngDetail from "./MbrAprvMngDetail";
import MbrAprvRejectReason from "./MbrAprvRejectReason";

interface Props {
    userId: string;
    userNm: string;
    setMemberModalOpen: Function;
    setCallTime : Function;
}

const MbrAprvMngDialog = ( {userId, userNm, setMemberModalOpen, setCallTime}: Props) => {
    const [viewType, setViewType] = React.useState<string>("D"); // 화면표시구분(회원상세정보[D], 반려사유[R])

    return (
        <>
            {viewType === "D" ?
                <MbrAprvMngDetail       // 회원상세정보
                    userId={userId}
                    setViewType={setViewType}
                    setMemberModalOpen={setMemberModalOpen}
                    setCallTime={setCallTime}
                ></MbrAprvMngDetail>
            :
                <MbrAprvRejectReason    // 반려사유 입력
                    userId={userId}
                    userNm={userNm}
                    setViewType={setViewType}
                    setMemberModalOpen={setMemberModalOpen}
                    setCallTime={setCallTime}
                ></MbrAprvRejectReason>
            }
        </>

    );
};

export default MbrAprvMngDialog;
